import React, { useState, useEffect } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Select, MenuItem } from '@mui/material';
import axios from 'axios';

const theme = createTheme({
  components: {
    MuiSelect: {
      styleOverrides: {
        root: {
          color: window.ENV.GENERAL.TEXT_COLOR,
          height: '30px',
          fontWeight: 500,
          fontFamily: window.ENV.FONT_FAMILY || 'UP-Light',
          backgroundColor: window.ENV.GENERAL.BACKGROUND_COLOR,
          '&:hover': {
            backgroundColor: window.ENV.GENERAL.TEXT_COLOR,
            color: window.ENV.GENERAL.BACKGROUND_COLOR,
          },
          '&.Mui-disabled': {
            backgroundColor: '#f5f5f5',
            color: '#bdbdbd',
            '&:hover': {
              backgroundColor: '#f5f5f5',
              color: '#bdbdbd',
            },
          },
        },
      },
    },
  },
});

const MySelect = ({ data, defaultValue, onChange, type, categoryName, datas, onSelectChange,selectedOption, setSelectedOption }) => {
  const [filterData, setFilterData] = useState([]);
  const [error, setError] = useState(null);
  useEffect(() => {
    console.log("🔍 MySelect Props Received:", { data, defaultValue, type, onChange });
  }, []);
  

  useEffect(() => {
    console.log("Datas:", datas); // Debugging: Ensure 'datas' is received properly
  }, [datas]);

  

  const downloadFiles = type === 'productDetails'
    ? [
        { value: '1', option: 'Select Format' },
        data['2d_drawing'] && { value: `${window.ENV.SERVER_URL}${data['2d_drawing']}`, option: '2D Drawing (.pdf)' },
        data['3d_pdf'] && { value: `${window.ENV.SERVER_URL}${data['3d_pdf']}`, option: '3D Drawing (.pdf)' },
        data['creo_parametric'] && { value: `${window.ENV.SERVER_URL}${data['creo_parametric']}`, option: 'Creo Parametric (.asm)' },
        data['cero_parametric_prt'] && { value: `${window.ENV.SERVER_URL}${data['cero_parametric_prt']}`, option: 'Creo Parametric (.prt)' },
        data['solidworks_format'] && { value: `${window.ENV.SERVER_URL}${data['solidworks_format']}`, option: 'Solidworks (.sldprt)' },
        data['step'] && { value: `${window.ENV.SERVER_URL}${data['step']}`, option: 'STEP (.stp)' },
        data['acis_format'] && { value: `${window.ENV.SERVER_URL}${data['acis_format']}`, option: 'ACIS (.sat)' },
        data['parasolid_format'] && { value: `${window.ENV.SERVER_URL}${data['parasolid_format']}`, option: 'Parasolid (.x_t)' },
        data['iges'] && { value: `${window.ENV.SERVER_URL}${data['iges']}`, option: 'IGES (.igs)' },
      ]
    :  [
      { value: "1", option: "Sort By" },
      ...datas?.flatMap((filterValue) => [
              // Both "Low to High" and "High to Low" for each filter
              { value: `${filterValue.name}-asc`, option: `${filterValue.name} Low to High` },
              { value: `${filterValue.name}-desc`, option: `${filterValue.name} High to Low` }
            ])
      // ...(datas[0]?.filter && typeof datas[0]?.filter === 'string'
      //   ? datas[0]?.filter.split(',').flatMap((filterValue) => [
      //       // Both "Low to High" and "High to Low" for each filter
      //       { value: `${filterValue}-asc`, option: `${filterValue.replace(/_/g, ' ')} Low to High` },
      //       { value: `${filterValue}-desc`, option: `${filterValue.replace(/_/g, ' ')} High to Low` }
      //     ])
        // : []),
    ];
  console.log("dowloadFiles:",downloadFiles);

  // Check if there are any valid download options (excluding the "Select Format" option)
  const hasValidOptions = type === 'productDetails' ? 
    downloadFiles.filter(item => item && item.value !== '1').length > 0 : 
    true;

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
    onSelectChange(event.target.value)
    // onSelectChange()
  };

  const dataKey = window.ENV.GOOGLE_SHEET_ID;


  return (
    <ThemeProvider theme={theme}>
      <Select 
        sx={{ fontSize: '14px', fontFamily: window.ENV.FONT_FAMILY || 'UP-Light' }} 
        value={selectedOption} 
        onChange={handleSelectChange}
        disabled={!hasValidOptions}
      >
        {downloadFiles.filter(item => item).map((item, key) => (
          <MenuItem key={key} value={item.value} sx={{ fontFamily: window.ENV.FONT_FAMILY || 'UP-Light' }}>
            {item.option}
          </MenuItem>
        ))}
      </Select>
    </ThemeProvider>
  );
};

export default MySelect;
